export const DEFAULT_PHONE_NUMBER_FORMAT = "(###) ###-####";

export function stripPhoneNumber(value: unknown): string {
  return String(value ?? "").replace(/\D/g, "");
}

export function formatPhoneNumber(value: unknown, format = DEFAULT_PHONE_NUMBER_FORMAT): string {
  const digits = stripPhoneNumber(value);

  if (!digits) {
    return "";
  }

  let digitIndex = 0;
  let formatted = "";

  for (const character of format) {
    if (character === "#") {
      if (digitIndex >= digits.length) {
        break;
      }

      formatted += digits[digitIndex];
      digitIndex += 1;
      continue;
    }

    if (digitIndex < digits.length) {
      formatted += character;
    }
  }

  if (digitIndex < digits.length) {
    formatted += digits.slice(digitIndex);
  }

  return formatted;
}
